import type { FC, SVGProps } from "react";

const Mute: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="mute video icon">
      {/* <title>mute video icon</title> */}
      <path
        d="M11.6056 4.09906C11.2007 3.9173 10.7246 3.98969 10.3929 4.2831L5.64084 8.48367H2.69014C1.75669 8.48367 1 9.23657 1 10.1338L1 13.4656C1 14.3944 1.75669 15.1158 2.69014 15.1158H5.64224L10.3922 19.3164C10.6029 19.5025 10.8704 19.6 11.1408 19.6C11.2971 19.6 11.4567 19.5672 11.6046 19.5004C12.0095 19.3197 12.2672 18.9202 12.2672 18.4787L12.2672 5.12033C12.2359 4.67924 12.0105 4.27949 11.6056 4.09906ZM19.095 11.8155L20.751 10.1678C21.0811 9.83934 21.0811 9.30734 20.751 8.97871C20.4209 8.65008 19.8862 8.65026 19.5559 8.97871L17.9014 10.6593L16.2148 9.00919C15.8847 8.68074 15.35 8.68074 15.0197 9.00919C14.6894 9.33764 14.6896 9.86965 15.0197 10.1983L16.6757 11.846L15.0197 13.4936C14.6896 13.8221 14.6896 14.3541 15.0197 14.6827C15.3497 15.0111 15.8845 15.0114 16.2148 14.6827L17.9014 13.0347L19.5574 14.6824C19.8874 15.0108 20.4221 15.011 20.7524 14.6824C21.0825 14.3539 21.0825 13.8219 20.7524 13.4933L19.095 11.8155Z"
        fill={props.fill || "currentColor" || "#F5F5F5"}
      />
    </svg>
  );
};

export default Mute;
